module.exports = __webpack_public_path__ + "static/media/friendventure-1.543294a3.JPG";